const URL_PATTERN =
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

export const isValidUrl = (input: unknown): input is string =>
  !!input && typeof input === "string" && !!input.match(URL_PATTERN);

export const pathWithoutQueryParams = (path?: string) =>
  path?.split("?")[0] ?? "";

// Returns true if both paths are equal after removing any query params
export const isSamePath = (path1?: string, path2?: string) =>
  Boolean(
    path1 &&
      path2 &&
      pathWithoutQueryParams(path1) === pathWithoutQueryParams(path2),
  );

/**
 * Checks if the first specified path is the same as, or a parent to, the second path.
 * Assumes paths are represented as strings and operates based on path segments.
 * Query parameters, if present, are not considered for this check.
 *
 * @param {string} path1 - The first path to check. This is the potential parent path.
 * @param {string} path2 - The second path to check. This is the potential child path.
 * @returns {boolean} True if the first path is the same as, or a parent of the second path.
 * Else returns False.
 *
 * @example
 *
 * isSameOrParentPath('/a/b', '/a/b/c')
 * // returns: true
 *
 * isSameOrParentPath('/a/b', '/a/b-c')
 * // returns: false
 */
export const isPathEqualOrSubpath = (path1?: string, path2?: string) => {
  if (!path1 || !path2) {
    return false;
  }

  const segments1 = pathWithoutQueryParams(path1).split("/").filter(Boolean);
  const segments2 = pathWithoutQueryParams(path2).split("/").filter(Boolean);

  return (
    segments1.length <= segments2.length &&
    segments1.every((seg, i) => seg === segments2[i])
  );
};

export const tryParseUrl = (url: string) => {
  try {
    return new URL(url);
  } catch (e) {
    return null;
  }
};
